<template>
  <div class="prototype-page">
    <div class="app-shell">
      <header class="page-header">
        <div class="header-inner">
          <div class="logo">
            <div class="logo-badge">3P</div>
            <span class="site-title">3P影视</span>
          </div>
          <div class="domain-display">
            <div class="domain-slider">
              <span v-for="(domain, idx) in domains" :key="idx" class="domain-item">{{ domain }}</span>
            </div>
          </div>
          <div class="header-action-pulse" @click="openFavoritePopup">
            <span>截图保存</span>
            <em>永久网址</em>
          </div>
        </div>
        <!-- <div class="search-bar-container">
          <div class="search-bar">搜索视频 / 分类 / 主播</div>
        </div> -->
      </header>

      <!-- <div class="favorite-entry-wrap">
        <button class="favorite-entry" type="button" @click="openFavoritePopup">
          <span class="favorite-entry__shine"></span>
          <span class="favorite-entry__icon">★</span>
          <span class="favorite-entry__text">
            <strong>收藏本站</strong>
            <em>点击一键保存，防止失联</em>
          </span>
          <span class="favorite-entry__arrow">›</span>
        </button>
      </div> -->

      <!-- <div class="notice-bar">{{ notice }}</div> -->

      <section class="section">
        <div class="section-title">
          <h2>视频分类</h2>
        </div>
        <div class="category-row" v-if="categories.length > 0">
        <div
          v-for="(item, index) in categories.slice(0, 9)"
          :key="item.id"
          class="chip-cool"
          :class="{ active: item.id === activeCategory }"
          @click="handleCategoryChange(item)"
        >
          <span class="chip-text">{{ item.name }}</span>
        </div>
      </div>
      </section>
      

       <div class="stack-list" v-if="bgAds.length">
        <router-link
          v-for="(ad, index) in bgAds"
          :key="ad.id"
          class="home-reference-banner"
          :style="adStyle(index)"
          :to="ad.url"
        >
          <span class="home-reference-banner__text">
            <em :style="{ color: adTagColor(index) }">【{{ ad.label.split(' ')[0] || '推荐' }}】</em>
            <strong>{{ ad.title }}</strong>
          </span>
          <span class="home-reference-banner__arrow">›</span>
        </router-link>
      </div>

    

      

      <section class="section" v-if="videoSection1.length">
        <div class="section-title">
          <h2>热门推荐</h2>
           <span @click="lookMore()">查看更多</span>
        </div>
        <div class="grid video-grid">
          <router-link
            v-for="(video, index) in videoSection1"
            :key="`${video.id || 'v1'}-${index}`"
            class="video-card"
            :to="withLdk(`/detail?id=${video.id}`)"
          >
            <div class="video-cover">
              <img :src="video.thumb_image" :alt="video.title">
              <span class="video-duration" v-if="video.times">{{ video.times }}</span>
            </div>
            <div class="video-body">
              <p class="video-title">{{ video.title }}</p>
              <div class="meta-row">
                <span>{{ video.day }}</span>
                <span>已有{{ video.rand }}人看过</span>
              </div>
            </div>
          </router-link>
        </div>
      </section>

      <div class="icon-ads" v-if="iconAds.length">
        <router-link v-for="ad in iconAds" :key="ad.id" :to="ad.url" class="icon-ad-item">
          <div class="icon-ad-thumb">
            <img :src="ad.thumb" :alt="ad.title" />
          </div>
          <span>{{ ad.title }}</span>
        </router-link>
      </div>
     

      <section class="section" v-if="videoSection2.length">
        <div class="section-title">
          <h2>最新更新</h2>
           <span @click="lookMore()">查看更多</span>
        </div>
        <div class="grid video-grid">
          <router-link
            v-for="(video, index) in videoSection2"
            :key="`${video.id || 'v2'}-${index}`"
            class="video-card"
           :to="withLdk(`/detail?id=${video.id}`)"
          >
            <div class="video-cover">
              <img :src="video.thumb_image" :alt="video.title">
              <span class="video-duration" v-if="video.times">{{ video.times }}</span>
            </div>
            <div class="video-body">
              <p class="video-title">{{ video.title }}</p>
              <div class="meta-row">
                <span>{{ video.day }}</span>
                <span>已有{{ video.rand }}人看过</span>
              </div>
            </div>
          </router-link>
        </div>
      </section>

      <div class="text-ads" v-if="textAds.length">
        <router-link
          v-for="(ad, index) in textAds"
          :key="ad.id"
          :to="ad.url"
          class="text-ad-item"
          :style="{ color: siteData.adPalette[index % siteData.adPalette.length].tag }"
        >
          {{ ad.title }}
        </router-link>
      </div>

      <section class="section" v-if="videoSection3.length">
        <div class="section-title">
          <h2>更多视频</h2>
          <span @click="lookMore()">查看更多</span>
        </div>
        <div class="grid video-grid">
          <router-link
            v-for="(video, index) in videoSection3"
            :key="`${video.id || 'v3'}-${index}`"
            class="video-card"
            :to="withLdk(`/detail?id=${video.id}`)"
          >
            <div class="video-cover">
             
              <img :src="video.thumb_image" :alt="video.title">
              <span class="video-duration" v-if="video.times">{{ video.times }}</span>
            </div>
            <div class="video-body">
              <p class="video-title">{{ video.title }}</p>
              <div class="meta-row">
                <span>{{ video.day }}</span>
                <span>已有{{ video.rand }}人看过</span>
              </div>
            </div>
          </router-link>
        </div>
      </section>

      <!-- <div class="helper-text" style="text-align: center; margin: 20px 0;">
        <span v-if="loading">加载中...</span>
        <span v-else-if="finished">没有更多了</span>
        <span v-else @click="loadMore" style="color: var(--primary);">点击加载更多</span>
      </div> -->

 <div class="module-ads" v-if="moduleAds.length">
        <router-link v-for="ad in moduleAds" :key="ad.id" :to="ad.url" class="module-ad-card">
          <img :src="ad.thumb" :alt="ad.title" />
        </router-link>
      </div>
 
    </div>
  
    <nav class="bottom-nav">
      <router-link
        v-for="item in navItems"
        :key="item.key"
        class="nav-item"
        :class="{ active: item.key === 'home' }"
        :to="withLdk(item.to)"
      >
        <div v-html="item.svg" class="nav-icon"></div>
        <span>{{ item.label }}</span>
      </router-link>
    </nav>

    <div v-if="showFavoritePopup" class="popup-mask show" @click="closeFavoritePopup">
      <div class="popup" @click.stop>
        <h3>收藏本站不迷路</h3>
        <p>建议收藏当前链接，避免链接失效后找不到入口，可保存到浏览器收藏夹或备忘录。</p>
        <div class="popup-actions">
          <div class="btn" @click="copyFavoriteLink">复制链接</div>
          <div class="ghost-btn" @click="closeFavoritePopup">我知道了</div>
          <div class="ghost-btn" @click="closeFavoritePopup">稍后再说</div>
        </div>
        <div class="helper-text" :class="popupFeedbackClass">{{ popupFeedback }}</div>
      </div>
    </div>

        <!-- 海报弹窗-->
    <van-dialog class="demo-dialog van-dialog detail-box" v-model="showFavoritePopup" :style="{ height: '540px' }"
      :showConfirmButton="false" :showCancelButton="false" :closeOnClickOverlay="true">
      <Sposter :params="params" @save-close="closePoster"></Sposter>
    </van-dialog>

    <AuthModal
      v-if="authVisible"
      :mode="authMode"
      @close="closeAuth"
      @change-mode="authMode = $event"
      @success="handleAuthSuccess"
    />
  </div>
</template>

<script>
import AuthModal from "@/views/AuthModal.vue";
import { navItems } from "@/prototype/navigation";
import {
  cacheNavUrlList,
  copyCurrentLink,
  decryptApiPayload,
  getCachedNavUrlList,
  getCoverUrl,
  markFavoritePopupShown,
  shouldShowFavoritePopup,
} from "@/prototype/render-helpers";
import { siteData } from "@/prototype/site-data";
import { nc6Api, iv6Api, vlv6Api, getAdsListApi } from "@/api/api";
import CryptoJS from "crypto-js";
import bplayer from "@/utils/bplayer";
import Sposter from '@/components/sposter.vue';
export default {
  name: "HomePage",
  components: {
    AuthModal,
    Sposter,
  },
  data() {
    return {
      activeCategory: 0,
      categories: [],
      dataList: [],
      initData: null,
      apiAds: [],
      initNotice: "",
      loading: false,
      finished: false,
      shebeiType: "",
      params: {
        page: 1,
        limit: 10,
        cate_id: 0,
        key: "",
        ldk: "",
        payed: 0,
        uid: "",
        templete_id: 1,
        webmanage: 0,
      },
      showFavoritePopup: false,
      popupFeedback: "",
      popupFeedbackClass: "",
      currentUser: { id: "", username: "", token: "" },
      authVisible: false,
      authMode: "login",
      navItems,
      siteData,
      domains: getCachedNavUrlList(),
    };
  },
  computed: {
    siteName() {
      return this.siteData.siteName;
    },
    notice() {
      return this.initNotice || this.siteData.notice;
    },
    videos() {
      return this.siteData.videos;
    },
    textAds() {
      const source = this.apiAds.length ? this.apiAds : this.siteData.ads;
      return source.filter((item) => item.position == 2 && item.type == 0);
    },
    bgAds() {
      const source = this.apiAds.length ? this.apiAds : this.siteData.ads;
      return source.filter((item) => item.position == 0 && item.type == 1);
    },
    iconAds() {
      const source = this.apiAds.length ? this.apiAds : this.siteData.ads;
      return source.filter((item) => item.position == 1 && item.type == 2);
    },
    moduleAds() {
      const source = this.apiAds.length ? this.apiAds : this.siteData.ads;
      return source.filter((item) => item.position == 2 && item.type == 3);
    },
    videoSection1() {
      return this.dataList.slice(0, 4);
    },
    videoSection2() {
      return this.dataList.slice(4, 8);
    },
    videoSection3() {
      return this.dataList.slice(8);
    },
    isLoggedIn() {
      return !!(this.currentUser && this.currentUser.id);
    }
  },
  mounted() {
    this.bootstrapHomeData();
    window.addEventListener("auth-changed", this.refreshAuthState);
  },
  beforeDestroy() {
    window.removeEventListener("auth-changed", this.refreshAuthState);
  },
  methods: {
    withLdk(to) {
    const ldk =
      this.params.ldk ||
      window.localStorage.getItem("ldk") ||
      "";

    if (!ldk) return to;

    // 🚫 外链不处理
    if (typeof to === "string" && /^https?:\/\//.test(to)) {
      return to;
    }

    // 🚫 已经带了 ldk
    if (typeof to === "string" && to.includes("ldk=")) {
      return to;
    }

    // 字符串
    if (typeof to === "string") {
      const hasQuery = to.includes("?");
      return `${to}${hasQuery ? "&" : "?"}ldk=${ldk}`;
    }

    // 对象
    if (typeof to === "object") {
      return {
        ...to,
        query: {
          ...(to.query || {}),
          ldk,
        },
      };
    }

    return to;
  },

  // ✅ push统一封装
  pushWithLdk(route) {
    const ldk =
      this.params.ldk ||
      window.localStorage.getItem("ldk") ||
      "";

    this.$router.push({
      ...route,
      query: {
        ...(route.query || {}),
        ldk,
      },
    });
  },
    closePoster(){
      this.showFavoritePopup = false;
    },
    async fetchAds() {
      try {
        const res = await getAdsListApi({ limit: 100 });
        const list = decryptApiPayload(res, this.$decryptData);
        if (Array.isArray(list)) {
          this.apiAds = list;
        }
      } catch (error) {
        console.error("Failed to fetch ads", error);
      }
    },
    bootstrapHomeData() {
      this.bootstrapLegacyDeps();
      this.refreshAuthState();
      this.params.ldk = this.resolveLandingKey();
      this.params.uid = window.localStorage.getItem("visitorId") || "";
      this.shebeiType = this.getDeviceType();
      this.fetchInitData();
      this.fetchAds();
      this.fetchCategories();
      this.fetchDataList();
    },
    bootstrapLegacyDeps() {
      if (!CryptoJS || !bplayer) {
        console.warn("Legacy deps unavailable");
      }
    },
    resolveLandingKey() {
      const routeLdk = this.$route && this.$route.query ? this.$route.query.ldk : "";
      const searchLdk = this.getURLParameter("ldk");
      const hashLdk = this.getHashParameter("ldk");
      const localLdk = window.localStorage.getItem("ldk") || "";
      const ldk = routeLdk || searchLdk || hashLdk || localLdk || "";
      if (ldk) {
        window.localStorage.setItem("ldk", ldk);
      }
      return ldk;
    },
    getURLParameter(name) {
      const safeName = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      const regex = new RegExp("[\\?&]" + safeName + "=([^&#]*)");
      const results = regex.exec(window.location.search);
      return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    },
    getHashParameter(name) {
      const safeName = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      const regex = new RegExp("[\\?&]" + safeName + "=([^&#]*)");
      const results = regex.exec(window.location.hash);
      return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    },
    getDeviceType() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/android/i.test(userAgent)) return 1;
      if (/iPad|iPhone|iPod/.test(userAgent)) return 2;
      return -1;
    },
    decryptPayload(payload) {
      try {
        const decryptedText = this.$decryptData(payload);
        return decryptedText ? JSON.parse(decryptedText) : null;
      } catch (error) {
        console.error("Failed to decrypt payload", error);
        return null;
      }
    },
    async fetchInitData() {
      try {
        const res = await iv6Api({
          ldk: this.params.ldk,
          payed: this.params.payed,
          shebei_type: this.shebeiType,
        });
        const temp = this.decryptPayload(res);
        if (!temp) {
          return;
        }
        this.initData = temp;
        this.initNotice = temp.tip_content || this.siteData.notice;
        const navUrlList = cacheNavUrlList(temp.navUrlList);
        if (navUrlList.length) {
          this.domains = [...navUrlList, navUrlList[0]];
        }
      } catch (error) {
        console.error("Failed to fetch init data", error);
      }
    },
    async fetchCategories() {
      try {
        const res = await nc6Api({ ldk: this.params.ldk });
        const list = this.decryptPayload(res);
        if (Array.isArray(list)) {
          this.categories = [{ id: 0, name: "全部" }, ...list];
        }
      } catch (error) {
        console.error("Failed to fetch categories", error);
      }
    },
    async fetchDataList(isRefresh = true) {
      if (isRefresh) {
        this.params.page = 1;
        this.finished = false;
        this.dataList = [];
      }
      
      if (this.loading || this.finished) return;
      this.loading = true;

      try {
        const currentPage = this.params.page;
        const res = await vlv6Api({
          ...this.params,
          key: this.params.key,
          cate_id: this.activeCategory,
          uid: this.params.uid || window.localStorage.getItem("visitorId") || "",
          sp: window.localStorage.getItem("sp"),
          ua: window.localStorage.getItem("parent"),
        });
        const temp = this.decryptPayload(res);
        if (!temp || !Array.isArray(temp.data)) {
          this.finished = true;
          return;
        }

        const nextList = temp.data;
        this.dataList = isRefresh ? nextList : [...this.dataList, ...nextList];
        this.finished = currentPage >= Number(temp.last_page || 1) || nextList.length === 0;

        if (!this.finished) {
          this.params.page += 1;
        }
      } catch (error) {
        console.error("Failed to fetch data list", error);
        this.finished = true;
      } finally {
        this.loading = false;
      }
    },
    loadMore() {
      this.fetchDataList(false);
    },
    handleCategoryChange(item) {
      this.activeCategory = item.id;
      this.$router.push({
        path: "/list",
        query: {
          category: item.name || "",
          cateId: item.id || 0,
        },
      });
    },
    lookMore() {
      this.$router.push({
        path: "/list",
        query: {
          category:"全部",
          cateId:  0,
          ldk: this.params.ldk,
        },
      });
    },
    getCoverUrl,
    adStyle(index) {
      const palette = this.siteData.adPalette[index % this.siteData.adPalette.length];
      return {
        background: palette.bg,
        color: palette.text,
      };
    },
    adTagColor(index) {
      return this.siteData.adPalette[index % this.siteData.adPalette.length].tag;
    },
    refreshAuthState() {
      try {
        const userInfo = window.localStorage.getItem("userInfo");
        this.currentUser = userInfo ? JSON.parse(userInfo) : { id: "", username: "", token: "" };
      } catch (error) {
        this.currentUser = { id: "", username: "", token: "" };
      }
    },
    handleHeaderAction() {
      if (this.isLoggedIn) {
        this.$router.push("/mine");
        return;
      }
      this.openAuth("login");
    },
    handleAuthSuccess(user) {
      this.currentUser = user || this.currentUser;
      this.refreshAuthState();
      this.closeAuth();
    },
    openAuth(mode) {
      this.authMode = mode;
      this.authVisible = true;
    },
    closeAuth() {
      this.authVisible = false;
    },
    openFavoritePopup() {
      this.popupFeedback = "";
      this.popupFeedbackClass = "";
      this.showFavoritePopup = true;
    },
    closeFavoritePopup() {
      markFavoritePopupShown();
      this.showFavoritePopup = false;
    },
    async copyFavoriteLink() {
      try {
        await copyCurrentLink();
        this.popupFeedbackClass = "success-text";
        this.popupFeedback = "链接已复制，请尽快保存到浏览器收藏夹或备忘录。";
      } catch (error) {
        this.popupFeedbackClass = "error-text";
        this.popupFeedback = "当前环境未能自动复制，请手动复制地址栏链接。";
      }
    },
  },
};
</script>

<style scoped>
.header-action-pulse {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  background: linear-gradient(135deg, #ff0055, #ffaa00);
  border-radius: 8px;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(255, 0, 85, 0.4);
  animation: pulse-glow 2s infinite;
  flex-shrink: 0;
}

.header-action-pulse span {
  font-size: 13px;
  letter-spacing: 0.5px;
}

.header-action-pulse em {
  font-size: 10px;
  font-style: normal;
  opacity: 0.9;
}

@keyframes pulse-glow {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 0, 85, 0.7);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 0 0 8px rgba(255, 0, 85, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 0, 85, 0);
  }
}

.favorite-entry-wrap {
  padding: 10px 12px 0;
}

.favorite-entry {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border: 0;
  border-radius: 16px;
  overflow: hidden;
  color: #ffffff;
  text-align: left;
  background: linear-gradient(135deg, #ff4d8d 0%, #7a5cff 45%, #16c7ff 100%);
  background-size: 200% 200%;
  box-shadow: 0 10px 24px rgba(122, 92, 255, 0.28);
  animation: favoriteGradientFlow 4s ease-in-out infinite;
}

.favorite-entry:active {
  transform: scale(0.98);
}

.favorite-entry__shine {
  position: absolute;
  top: 0;
  left: -35%;
  width: 32%;
  height: 100%;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.45), rgba(255, 255, 255, 0));
  transform: skewX(-24deg);
  animation: favoriteShine 2.8s linear infinite;
}

.favorite-entry__icon,
.favorite-entry__text,
.favorite-entry__arrow {
  position: relative;
  z-index: 1;
}

.favorite-entry__icon {
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.18);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.22);
  font-size: 18px;
  text-shadow: 0 0 12px rgba(255, 255, 255, 0.65);
  animation: favoritePulse 1.8s ease-in-out infinite;
}

.favorite-entry__text {
  min-width: 0;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;
}

.favorite-entry__text strong {
  font-size: 15px;
  line-height: 1.2;
}

.favorite-entry__text em {
  font-style: normal;
  font-size: 12px;
  opacity: 0.92;
}

.favorite-entry__arrow {
  font-size: 26px;
  line-height: 1;
  opacity: 0.95;
  transform: translateX(0);
  animation: favoriteArrowMove 1.2s ease-in-out infinite;
}

@keyframes favoriteGradientFlow {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes favoriteShine {
  0% {
    left: -40%;
  }
  100% {
    left: 120%;
  }
}

@keyframes favoritePulse {
  0%,
  100% {
    transform: scale(1);
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.22), 0 0 0 rgba(255, 255, 255, 0);
  }
  50% {
    transform: scale(1.08);
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.3), 0 0 18px rgba(255, 255, 255, 0.32);
  }
}

@keyframes favoriteArrowMove {
  0%,
  100% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(4px);
  }
}

.module-ads {
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.module-ad-card {
  display: block;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  max-height: 60px;
}
.module-ad-card img {
  width: 100%;
  height: auto;
  display: block;
}

.icon-ads {
  display: flex;
  overflow-x: auto;
  gap: 12px;
  padding: 10px 14px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none; /* Firefox */
}
.icon-ads::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}
.icon-ad-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  text-decoration: none;
  color: var(--text);
  font-size: 12px;
  flex-shrink: 0;
  width: 56px;
}
.icon-ad-thumb {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  overflow: hidden;
  background: #f5f5f5;
}
.icon-ad-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.text-ads {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px 14px;
}
.text-ad-item {
  padding: 6px 12px;
  background: #000000;
  border-radius: 16px;
  font-size: 13px;
  color: var(--text);
  text-decoration: none;
}
</style>
